import { z } from 'zod';
import { BusinessDateSchema } from './time';

/**
 * Where a record came from when it was not created by the normal workflow (Release-1 onboarding,
 * BD-63). Written once, never edited: it is the provenance an auditor follows back to the source
 * batch and the client's own document number.
 *
 * Kept in its own file with no domain imports so `sales` and `collections` can both use it without an
 * import cycle through the onboarding column catalogue.
 */
export const HistoricalOriginSchema = z.strictObject({
  kind: z.literal('historicalImport'),
  /** The source namespace of the import, e.g. `LEGACY-ERP`. */
  sourceNamespace: z.string(),
  /** The record's identifier in the source system — unique within the namespace and legal entity. */
  sourceId: z.string(),
  /** The client's own document number (contract or receipt), kept as entered. */
  originalNumber: z.string().optional(),
  /** The import batch that wrote it. */
  batchId: z.string(),
  /** The cutover date in force when it was imported: the record predates it. */
  cutoverDate: BusinessDateSchema,
});
export type HistoricalOrigin = z.infer<typeof HistoricalOriginSchema>;
